import _get from 'lodash/get'

export function mounted() {
  this.unitID = this.currentUnitId
    ? this.currentUnitId
    : _get(this, 'authUser.ownerUser.unitID', null)

  this.getRefreshedLeases()

  if (this.isDebug == true) {
    console.debug('mounted unitID=' + this.unitID)
  }

  this.resetForm()
}
